<div class="p-20 text-center">
  <div class="close_bg display-content-end" (click)="closeDialog()">
    <img class="cp" src="././assets/icon/close_icon.png">
  </div>
  <img src="{{image}}" class="p-10">
</div>